__turbopack_context__.v({
  "body": "SeoContentComponent-module-scss-module__jb_yMa__body",
  "container": "SeoContentComponent-module-scss-module__jb_yMa__container",
  "heading": "SeoContentComponent-module-scss-module__jb_yMa__heading",
  "left": "SeoContentComponent-module-scss-module__jb_yMa__left",
});
